import Api from './api';

const BalancoService = {


    listar: async (params) => {
        const response = await Api({
            method: 'get',
            url: '/balanco/listar',
            params: params
        })
        return response
    },
    numBalancos: async (params) => {
        return Api({
            method: 'get',
            url: '/balanco/numbalancos',
            params: params
        })
    },
    buscar: (params) => {
        const response = Api.get(`/balanco/buscar?${params}`)
        return response
    },
    tipos: async (params) => {
        const response = await Api({
            method: 'get',
            url: '/balanco/tipos',
            params: params
        })
        return response
    }
}

export default BalancoService;